import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref, watch } from 'vue'

import AxisInput from '../components/axisInput.vue'
import CodeInput from '../components/codeInput.vue'
import FormItem from '../components/formItem.vue'
import inputTableVue from '../components/inputTable.vue'
import { Knif } from '../util/types'
import { axisList, codeList, knivesColumns } from './customFirstConf'


export default /*#__PURE__*/_defineComponent({
  __name: 'customFirst',
  props: {
    data: null
  },
  emits: ['onDataChange'],
  setup(__props: any, { emit }) {

const props = __props as { data: any }





const formData = reactive<{ [key: string]: any }>({
  beginCode: '',
  pauseCode: '',
  collectKnifeCode: '',
  frontTurnCode: '',
  backTurnCode: '',
  leftTurnCode: '',
  rightTurnCode: '',
  endCode: '',
  startCode: '',
  stopCode: '',
  moveCode: '',
  moveAxisCode: '',
  pushAxisCode: '',
  swingAxisCode: '',
  knives: {},
})

const tableData = ref<Knif[]>([])

// 表单数据传出
watch(
  () => formData,
  (val) => {
    emit('onDataChange', val)
  },
  {
    deep: true,
  }
)

// 表单数据传入处理
watch(
  () => props.data,
  (val) => {
    if (val) {
      for (const key in formData) {
        formData[key] = val[key]
      }
      tableData.value = []
      for (const key in formData.knives) {
        tableData.value.push(Knif.fromFirstSetting(formData.knives[key]))
      }
    }
  },
  {
    immediate: true,
  }
)
// 刀具库改动监听处理
watch(
  () => tableData.value,
  (val) => {
    if (val) {
      let knives: { [key: string]: any } = {}
      val.forEach((knif) => {
        knives[knif.id] = knif
      })
      formData.knives = knives
    }
  },
  {
    deep: true,
  }
)

return { __sfc: true,props, emit, formData, tableData, AxisInput, CodeInput, FormItem, inputTableVue, axisList, codeList, knivesColumns }
}

})